import newsService from "../../services/newsService/service";
import NewsModel from "../../models/newsModel/model";
export default {
    async getNews(search, page, limit, company) {
        try{
            const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
            const {data,headers} = await newsService.getNews(sanitizedSearch, page, limit, company);
            return {
                data: data.map(news => new NewsModel(news)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error('Error fetching news:', error);
            throw error;
        }
    },
    async totalAllNews(search, company_id) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            return await newsService.totalAllNews(sanitizedSearch, company_id);
        } catch (error) {
            console.error('Error fetching news:', error);
            throw error;
        }
    },
    async addNews(news) {
        try {
            return await newsService.addNews(news);
        } catch (error) {
            console.error('Error adding news:', error);
            throw error;
        }
    },
    async updateNews(news) {
        try {
            return await newsService.updateNews(news);
        } catch (error) {
            console.error('Error updating news:', error);
            throw error;
        }
    },
    async deleteNews(newsId, newsGambar) {
        try {
            return await newsService.deleteNews(newsId, newsGambar);
        } catch (error) {
            console.error('Error deleting news:', error);
            throw error;
        }
    },
}